<template>
  <section class="google-map">
    <transition name="fade" mode="out-in">
      <div
        v-if="tollTipShow"
        @click="tollTipShow = false"
        class="google-map__text-wrap"
      >
        <div  class="google-map__text-inner-wrap">
          <div class="google-map__text" v-html="toolTip"></div>
          <svg class="google-map__close">
            <use xlink:href="#icon-times-light"></use>
          </svg>
        </div>
      </div>
    </transition>
    <div ref="map" style="width: 100%; height: 100%"></div>
  </section>
</template>

<script>
import axios from "axios";
import config from '../../utils/config';
export default {
  name: "GoogleMap",
  data() {
    return {
      map: false,
      lat: 0,
      lng: 0,
      radius: 0,
      places: [],
      tollTipShow: true,
    };
  },
  methods: {
    setMap() {
      this.map = new google.maps.Map(this.$refs["map"], {
        center: {
          lat: this.lat,
          lng: this.lng,
        },
        mapTypeId: google.maps.MapTypeId.SATELLITE,
        streetViewControl: false,
        zoom: 7,
      });
      this.setMarker();
      this.getCity();
    },
    getCity() {
      this.map.addListener("click", (e) => {
        const cord = e.latLng.toJSON();

        const geocoder = new google.maps.Geocoder();
        const latlng = {
          lat: cord.lat,
          lng: cord.lng,
        };
        geocoder
          .geocode({ location: latlng })
          .then((res) => {
        
            const results = res.results[0];
            if (results) {
              this.places = results.address_components.map(
                (item) => item.long_name
              );
              this.getCat();
            } else {
              window.alert("No results found");
            }
          })
          .catch((e) => window.alert("Geocoder failed due to: " + e));
      });
    },
    async getCat() {
      const configs = config
      configs.headers["NETOAPI_ACTION"] = "GetCategory";

      for (let i = 0; i < this.places.length; i++) {
        const resCat = await axios.post(
          "https://www.skyepics.com.au/do/WS/NetoAPI",
          {
            Filter: {
              CategoryName: this.places[i],
              OutputSelector: ["CategoryID", "ShortDescription1"],
              Active: true,
            },
          },
          configs
        );
        const cat = resCat.data.Category;       
        if (cat.length > 0) {
          window.location.href = `${window.location.origin}${
            cat[cat.length - 1].ShortDescription1
          }`;

          return;
        }
      }

      // if (cat.length !== 0) {
      //   window.location.href = `${window.location.origin}${
      //     cat[cat.length - 1].ShortDescription1
      //   }`;
      // }
    },
    setMarker() {
      const latLng = new google.maps.LatLng(this.lat, this.lng);
      new google.maps.Marker({
        position: latLng,
        title: "Marker",
        map: this.map,
        draggable: true,
      });
    },
    setPolygon() {
      const cityCircle = new google.maps.Circle({
        center: { lat: this.lat, lng: this.lng },
        radius: this.radius,
      });

      this.cityPolygon = new google.maps.Rectangle({
        strokeColor: "#FFF",
        strokeOpacity: 1,
        strokeWeight: 3,
        fillOpacity: 0,
        map: this.map,
        bounds: cityCircle.getBounds(),
      });
      this.cityPolygon.setMap(this.map);

      this.cityPolygon.addListener("click", (e) => {
        const cord = e.latLng.toJSON();
        this.setSearchCord(cord);
        this.filterProds();
      });
    },

    setCord(cord, radius) {
      this.lat = cord.lat ? cord.lat : -26.4390917;
      this.lng = cord.lng ? cord.lng : 133.281323;
      this.radius = radius;
    },
  },
  computed: {
    toolTip() {
      return window.mapTollTip;
    },
  },
  mounted() {
    this.setCord(window.cord, window.radius);
    this.setMap();
  },
};
</script>
